import { darken } from '@material-ui/core';
import { FaFileImport } from 'react-icons/fa';
import styled from 'styled-components';

export const Item = styled.div`
  padding: 10px;
  margin: 0 0 10px 0;
  border-radius: 5px;
  background: #e8e8e8;
  cursor: move;
`;

export const CheckboxContainer = styled.div`
  display: flex;
`;

export const StyledCheckbox = styled.input`
  margin-right: 0.5rem;
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

export const FileIcon = styled(FaFileImport)`
  margin-bottom: 8px;
  font-size: 24px;
`;

export const AddMorePhones = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border-radius: 4px;
  background: ${(props) => props.color};
  color: white;

  &:hover {
    background: ${(props) => darken(props.color, 0.1)};
  }

  & > * {
    color: white;
  }

  & > *:hover {
    color: white;
  }
`;

export const ModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1em;
`;
